import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { PaginatedResponse } from '@/core/api/dtos/common/types'
import { Account } from '@/core/api/entities/account/account'
import { AccountMapper } from '@/core/api/mappers/account/accountMapper'
import { accountService } from '@/core/api/services/account/accountService'
import { DEFAULT_PARAMS } from '@/core/hooks/common'

/**
 * Get accounts with pagination and search
 */
export const useAccounts = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<PaginatedResponse<Account>, Error> => {
	const QUERY_KEY = ['accounts', 'paginated', config?.params]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			accountService.paginateAccounts(config).then(({ data: response }) => {
				return {
					data: AccountMapper.toEntities(response?.data || []),
					meta: response?.meta,
				}
			}),
		...options,
	})
}
